import purchaseAdditionalConcurrentDevicesFeatures from './PurchaseAdditionalConcurrentDevices';
import concurrentDevicesFeatures from './ConcurrentDevices';

const deviceFeatures = ({ packages }) => ({
  concurrentDevices: {
    key: 'concurrent-devices',
    label: 'concurrentDevices',
    values: concurrentDevicesFeatures({ packages }),
  },
  purchaseAdditionalConcurrentDevices: {
    key: 'purchase-additional-concurrent-devices',
    label: 'purchaseAdditionalConcurrentDevices',
    values: purchaseAdditionalConcurrentDevicesFeatures({ packages }),
  },
});

export default deviceFeatures;
